import React, { useEffect } from "react";
import { omitBy, isEmpty, isNil } from "lodash";

interface SearchProps {
  onFilter: any;
  filterState: any;
  setFilterState: any;
}

const useSearch = (props: SearchProps) => {
  const { onFilter, filterState, setFilterState } = props || {};

  useEffect(() => {
    if (onFilter && !isEmpty(filterState)) {
      const filterPayload = omitBy(filterState, (input) => isNil(input) || isEmpty(input));
      onFilter(filterPayload);
    }
  }, [filterState]);

  const handleSearch = async (text: string) => {
    setFilterState((prevFilter) => ({ ...prevFilter, orFields: text }));
  };

  const handleFilterSelection = (selection) => {
    setFilterState((prevFilter) => ({
      ...prevFilter,
      ...selection,
    }));
  };

  return {
    handleSearch,
    handleFilterSelection,
  };
};

export default useSearch;
